import { render, staticRenderFns } from "./EditDepartmentHodCombination.vue?vue&type=template&id=3265b620"
import script from "./EditDepartmentHodCombination.vue?vue&type=script&lang=js"
export * from "./EditDepartmentHodCombination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports